let config=null;
let captchaId='';
let tencentCaptchaId='';
if(process.env.mode=='development'){
    config = {
        //baseUrl:'http://192.168.2.233:8889/fx168-user',
        //baseUrl:'http://192.168.2.233:8087',
        //baseUrl:'http://192.168.2.233:8118/fx168-user',
        baseUrl:'https://testcenterapi.2rich.net/user',
    };
    captchaId='5bf89a6b1e8446fc8f45c5e99f07135c';
    tencentCaptchaId="194776007";
}else{
    config = {
        baseUrl:'https://centerapi.fx168api.com/user',
    };
    captchaId='5bf89a6b1e8446fc8f45c5e99f07135c';
    tencentCaptchaId="194776007";
}
export {config,captchaId,tencentCaptchaId};